import { DataSource, Image, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSCACCarrierQuickInfo extends Layout {
    imageDetailLink: Image;
    panelScacCarrierQuickInfo: Panel;
    sourceCarrierScac: DataSource;
    textboxName: Textbox;
    textboxP: Textbox;
}
